import { ReactNode } from 'react';

import { EnvironmentAndMenu } from '../../../utils/contexts';
import { useEnv } from '../../../utils/hooks';
import { NotFoundPage } from '../../ErrorPage';

interface RequireEnvConditionProps {
  children: ReactNode;
  check: (env: EnvironmentAndMenu) => boolean;
}

export const RequireEnvCondition = ({ children, check }: RequireEnvConditionProps) => {
  const env = useEnv();

  if (!env || !check(env)) return <NotFoundPage />;

  return <>{children}</>;
};
